import { useParams } from 'react-router'
import { useGoToPath } from 'utils/routing/navigation.hooks'
import { type PartnerScopedRouteParams } from 'legacy/common/types'

export interface GoToAccountManagementPageProps {
  accountCanonicalId: string
}

export const useGoToAccountManagementPage = (props: GoToAccountManagementPageProps) => {
  const { partner_id: partnerId } = useParams<PartnerScopedRouteParams>()

  const editAccountPath = partnerId
    ? 'retailer-account-management-edit'
    : 'app-admin-account-management-edit'

  const goToEditAccount = useGoToPath(editAccountPath, {
    accountCanonicalId: props.accountCanonicalId,
  })

  return goToEditAccount
}
